import { Feature } from 'src/store/app/types';
import { Store } from 'src/store/index';

const isFeatureEnabled = (store: Store, feature: Feature) => store.app.features.indexOf(feature) !== -1;

export default isFeatureEnabled;
